import _extends from '/app/node_modules/babel-runtime/helpers/extends';
import { mapGetters } from 'vuex';

export var documentNumberAndTypeFormMixin = {
    data: function data() {
        return {
            maxLengthDocumentNumber: 0
        };
    },

    watch: {
        documentType: function documentType(val) {
            this.documentNumber = "";
            switch (val.Code) {
                case 'DNI':
                    this.maxLengthDocumentNumber = 8;
                    break;
                case 'CEX':
                    this.maxLengthDocumentNumber = 9;
                    break;
                case 'RUC':
                    this.maxLengthDocumentNumber = 11;
                    break;
                case 'PAS':
                    this.maxLengthDocumentNumber = 12;
                    break;
                default:
                    this.maxLengthDocumentNumber = 0;break;
            }
        }
    },
    computed: _extends({}, mapGetters({
        documentTypes: ['master-data/documentTypes']
    }), {
        documentNumberErrorMessages: function documentNumberErrorMessages() {
            var errors = [];
            if (!this.$v.documentNumber.$dirty) return errors;
            !this.$v.documentNumber.required && errors.push('Debes ingresar el número de documento');
            !this.$v.documentNumber.numeric && errors.push('Ingresa sólo números');
            !this.$v.documentNumber.minLength && errors.push('Debes ingresar m\xEDnimo ' + this.maxLengthDocumentNumber + ' n\xFAmeros');
            return errors;
        },
        documentTypeErrorMessages: function documentTypeErrorMessages() {
            var errors = [];
            if (!this.$v.documentType.$dirty) return errors;
            !this.$v.documentType.required && errors.push('Debes seleccionar el tipo de documento');
            return errors;
        }
    })
};


//////////////////
// WEBPACK FOOTER
// ./src/mixins/document-number-and-type-form.js
// module id = ./src/mixins/document-number-and-type-form.js
// module chunks = 34